import { render, staticRenderFns } from "./PainelPrograd.vue?vue&type=template&id=40545174"
import script from "./PainelPrograd.vue?vue&type=script&lang=js"
export * from "./PainelPrograd.vue?vue&type=script&lang=js"
import style0 from "./PainelPrograd.vue?vue&type=style&index=0&id=40545174&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports